<template>
  <v-dialog v-model="$loja_consumidor.dialogItens" max-width="1300">
    <v-card class="rounded-lg">
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("customers.order-items") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div
        class="itens-pedidos-consumidor-container03"
        v-if="
          $loja_consumidor.itens_pedido &&
          $loja_consumidor.itens_pedido.length == 0 &&
          !$loja_consumidor.loading_itens_pedido
        "
      >
        <span>{{ $t("customers.no-results-found") }}</span>
      </div>
      <v-progress-linear
        indeterminate
        v-else-if="$loja_consumidor.loading_itens_pedido"
        color="#393939"
      ></v-progress-linear>
      <v-data-table
        class="itens-pedidos-consumidor-container03 pa-4"
        :headers="headers"
        :items="tableValues"
        v-else
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10],
          itemsPerPageText: $t('customers.items-per-page'),
        }"
      >
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  :disabled="
                    item.status != 'Pago' ||
                    item.tipo === 'RECARGA' ||
                    item.tipo_produto === 'RECARGA'
                  "
                  v-on="on"
                  @click="
                    $marketplace_consumidor.imprimirIngresso(
                      item.iditem,
                      item.sequenciador
                    )
                  "
                >
                  <v-icon>mdi-printer-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customers.print") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalItensPedidoConsumidor",
  computed: {
    headers() {
      return [
        {
          text: this.$t("customers.locator"),
          align: "center",
          sortable: true,
          value: "localizador",
        },
        {
          text: this.$t("customers.item-description"),
          align: "center",
          sortable: true,
          value: "dsc_produto",
        },
        {
          text: "SKU",
          align: "center",
          sortable: true,
          value: "sku",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: this.$t("customers.reservation-date"),
          align: "center",
          sortable: true,
          value: "dthr_reserva",
        },
        {
          text: this.$t("customers.payment-date"),
          align: "center",
          sortable: true,
          value: "dthr_pagamento",
        },
        {
          text: this.$t("customers.value"),
          align: "center",
          sortable: false,
          value: "valor",
        },
        {
          text: this.$t("customers.fees-value"),
          align: "center",
          sortable: false,
          value: "valor_juros",
        },
        {
          text: this.$t("customers.discount-value"),
          align: "center",
          sortable: false,
          value: "valor_desconto",
        },
        {
          text: this.$t("customers.total-value"),
          align: "center",
          sortable: false,
          value: "valor_total",
        },
        {
          text: this.$t("customers.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
    },
    tableValues() {
      this.$loja_consumidor.itens_pedido.forEach(item => {
        item.localizador = item.localizador ? item.localizador : "-";
        item.sku = item.sku ? item.sku : "-";
        item.status = item.status ? item.status : "-";
        item.dthr_pagamento = item.dthr_pagamento
          ? this.$config.convertDataBR(item.dthr_pagamento.substring(0, 10))
          : "-";
        item.dthr_reserva = item.dthr_reserva
          ? this.$config.convertDataBR(item.dthr_reserva.substring(0, 10))
          : "-";
        item.valor = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor));
        item.valor_juros = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor_juros));
        item.valor_desconto = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor_desconto));
        item.valor_total = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor_total));
      });
      return this.$loja_consumidor.itens_pedido;
    },
  },
  methods: {
    closeModal() {
      this.$loja_consumidor.itens_pedido = [];
      this.$loja_consumidor.dialogItens = false;
    },
  },
};
</script>

<style scoped>
.itens-pedidos-consumidor-container03 {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
  overflow-y: auto;
}
</style>
